/* eslint-disable @typescript-eslint/no-explicit-any */
export type SilentValueChange = [string, unknown];

/**
 * Пишет значения без пометки modified, поэтому getIsDirty* не считают это правкой пользователя и не снимают подпись.
 * Все изменения идут одним вызовом, чтобы валидация и подписчики формы отработали один раз.
 */
export const setValuesSilent = ([changes]: [SilentValueChange[]], state: any, utils: any) => {
  changes.forEach(([name, value]) => {
    utils.changeValue(state, name, () => value);
  });
};
